import {useEffect} from "react";
import {useTranslation} from "react-i18next";
import {useSearchParams} from "react-router-dom";

const SUPPORTED_LANGUAGES = ["en", "ru", "uk", "pl"];

export function useEmailLinkLanguage() {
    const {i18n} = useTranslation();
    const [searchParams] = useSearchParams();
    const language = searchParams.get("language");

    useEffect(() => {
        if (language && SUPPORTED_LANGUAGES.includes(language) && i18n.language !== language) {
            i18n.changeLanguage(language);
        }
    }, [language, i18n]);

    return {searchParams, language: language ?? i18n.language};
}
